import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/order/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-1ff8dc60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "express-drawer-content" }
const _hoisted_2 = { class: "express-drawer-product flex-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "sku" }
const _hoisted_5 = { class: "sku-title" }
const _hoisted_6 = { class: "sku-text" }
const _hoisted_7 = { class: "sku-text-name" }
const _hoisted_8 = { class: "sku-text-num" }
const _hoisted_9 = {
  key: 0,
  class: "express-empty"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "empty-text" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "express-drawer-tags"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "express-empty"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = { class: "empty-text" }
const _hoisted_18 = { class: "feedback-time" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-gantanhao cursor-pt iconfont-size" }, null, -1))
const _hoisted_20 = { style: {"margin-left":"8px"} }
const _hoisted_21 = { class: "info-content" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "info-content-detail" }
const _hoisted_24 = {
  key: 0,
  class: "stock-time"
}
const _hoisted_25 = { class: "special" }
const _hoisted_26 = {
  key: 1,
  class: "logistics-number"
}
const _hoisted_27 = { style: {"margin-left":"8px","margin-right":"8px"} }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "title" }
const _hoisted_30 = {
  key: 0,
  class: "iconfont icon-zhankai2"
}
const _hoisted_31 = {
  key: 1,
  class: "iconfont icon-shouqi2"
}
const _hoisted_32 = {
  key: 0,
  class: "express-log-list"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-log-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-yunshujindu_tianchong" })
], -1))
const _hoisted_34 = {
  key: 0,
  class: "express-log-item-right"
}
const _hoisted_35 = { class: "express-log-status active" }
const _hoisted_36 = { class: "status-text" }
const _hoisted_37 = { class: "time" }
const _hoisted_38 = { class: "status-detail" }
const _hoisted_39 = { class: "status-text point" }
const _hoisted_40 = { class: "time" }
const _hoisted_41 = { class: "status-detail" }
const _hoisted_42 = {
  key: 0,
  class: "express-log-item"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-log-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-yunshujindu_xianxing" })
], -1))
const _hoisted_44 = { class: "express-log-item-right" }
const _hoisted_45 = { class: "express-log-status" }
const _hoisted_46 = { class: "status-text" }
const _hoisted_47 = { class: "time" }
const _hoisted_48 = { class: "status-detail" }
const _hoisted_49 = {
  key: 1,
  class: "express-log-empty"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_51 = { class: "empty-text" }

import { t } from '@/plugins/i18n'
import { ref, computed, onMounted } from 'vue'
import Drawer from '@/components/common/Drawer.vue'
import dayjs from 'dayjs'
import { drawerDocumentaryLogisticsData, drawerDocumentaryRecordData, logisticsTagsObj, abnormalType, purchaseRemark, handleType } from '../OrderSearch/data'
import { productStatsEnum } from '../data'
import { getJapanTime } from '@/util/common'

export default /*#__PURE__*/_defineComponent({
  emits: ['update:visible'],
  setup(__props, { expose, emit }) {

const expressDrawerVisible = ref(false)

const expressInfo: any = ref([])
const expressRow: any = ref([])
const expressStatus: any = ref()
// 选中的采购id
const selectedPurchaseId = ref()
const close = () => {
  expressDrawerVisible.value = false
}
// 获取tips的样式
const getTipsClass = (item:any) => {
  // 颜色：1 黄色； 2绿色
  if (item.colour === 2) {
    return 'info-tip info-tip-green'
  }
  return 'info-tip'
}
/** 获取选中的发货信息 */
const getExpressInfoItemRespDtos = () => {
  if (Number(expressInfo.value.length ?? 0) > 1) {
    const newData = expressInfo.value.find((item:any) => item.purchaseId === selectedPurchaseId.value)
    return newData.itemRespDtos ?? []
  }
  return expressInfo.value[0].itemRespDtos ?? []
}

const productStatsKeyEnum: any = {
  1: 'waitPurchaeQuantity',
  2: 'purchasingQuantity',
  3: 'hasPurchaeQuantity',
  4: 'expressQuantity',
  5: 'stockInQuantity',
  6: 'checkingQuantity',
  7: 'checkedQuantity',
  8: 'deliveredQuantity',
  9: 'hasDeliverQuantity',
  10: 'confirmQuantity',
  11: 'badClientQuantity',
  // 11: 'badClientQuantity',
  12: 'cancleAndRefundQuantity',
  13: 'keepStockQuantity',
  14: 'onTheWayFreezeQuantity'
}

// 获取到货或者发货时间
const getStockTime = (item: any) => {
  // 1 物流 2跟单
  if (Number(item.type) === 2) {
    return { text: t('预计发货时间'), time: item.expectedDeliveryTime ?? t('无2') }
  }
  // 国内运输中
  if (Number(item.type) === 1) {
    return { text: t('预计到货时间'), time: item.latestEstimateStockTime ?? t('无2') }
  }
  return null
}
/** 获取提示文案 */
const getTipsText = (row:any) => {
  // 物流-签收状态 0 1已签收
  if (row.signStatus === 1) {
    return t('已到货，入库中')
  }
  //   COMMONT_PRODUCT(1, "普通商品"),
  // OEM_PRODUCT(2, "OEM商品"),
  // COMBINATION_PRODUCT(3, "组合商品"),
  // 如果是oem商品,物流标签展示原来的
  if (String(row.productType) === '2' && row.type === 1) {
    if (Number(row.logisticsTag)) { return logisticsTagsObj[Number(row.logisticsTag)] }
    return ''
  }
  //   类型：1 物流 2跟单
  if (row.type === 1) {
    // 先取跟单-异常父类型
    const newData = drawerDocumentaryLogisticsData.find((item) => item.abnormalType === Number(row.abnormalType))?.abnormalList ?? []
    // 再取跟单-异常子类型
    const logisticTagList = newData.find((item) => item.value === Number(row.abnormalDetailType))?.logisticTagList ?? []
    // 无物流标签展示文案
    const noLogisticTagText = newData.find((item) => item.value === Number(row.abnormalDetailType))?.noLogisticTagText
    const text = row.logisticsTag ? logisticTagList.find((item) => item.value === Number(row.logisticsTag))?.tip : noLogisticTagText
    // 替换翻译的X
    const lastText = text ? text.replace('X', row.latestEstimateStockTime).replace('Y', row.count) : ''
    return lastText ?? ''
  }
  const isSpecialType = getSpecialType(row)
  //   当为某个类型下的，时间需要加3天（文案为（预计到仓时间规则=预计发货时间+3天同现在））
  const timeAddThree = row.expectedDeliveryTime ? dayjs(row.expectedDeliveryTime).add(3, 'day').format('YYYY-MM-DD') : ''
  const lastTime = isSpecialType ? timeAddThree : row.expectedDeliveryTime

  // 先取跟单-异常父类型
  const newData = drawerDocumentaryRecordData.find((item) => item.abnormalType === Number(row.abnormalType))?.abnormalList ?? []
  // 再取跟单-异常子类型
  const radioList = newData.find((item) => item.value === Number(row.abnormalDetailType))?.radioList ?? []
  // 再取跟单-跟单处理类型
  const obj:any = radioList.find((item) => item.value === Number(row.operateType)) ?? {}
  // 如果有tip直接返回
  if (obj?.tip) {
    return obj?.tip.replace('X', lastTime ?? t('无2')).replace('Y', row.count)
  }
  const list = obj?.list ?? []
  const text = list.find((item:any) => item.value === Number(row.remarkReasonType))?.tip ?? ''
  // 替换翻译的X
  const lastText = text ? text.replace('X', lastTime ?? t('无2')).replace('Y', row.count) : ''
  return lastText ?? ''
}

/** 获取特殊的类型-该类型下时间需要加三天，用中文判断不太准确，所以采用类型判断 */
const getSpecialType = (row:any) => {
  // 当不为到货异常直接return false
  if (Number(row.abnormalType) !== 3) {
    return false
  }
  const arr = [
    abnormalType.partInStock,
    abnormalType.arrivalOutTimeAbnormal,
    abnormalType.confirmTimeAbnormal,
    abnormalType.noShipTime,
    abnormalType.noShipTimeAbnormal
  ]
  if (!arr.includes(Number(row.abnormalDetailType))) {
    return false
  }
  if (
    Number(row.operateType) === handleType.haveSendTime &&
Number(row.remarkReasonType) === purchaseRemark.changeTimeProducting) {
    return true
  }
  return false
}

const open = (data: any) => {
  expressInfo.value = data.info?.map((item: any) => {
    if (item?.itemRespDtos && item.itemRespDtos?.length) {
      item.itemRespDtos = item.itemRespDtos.map((sonItem: any) => {
        return { ...sonItem, show: false }
      })
    }
    return { ...item }
  })
  expressStatus.value = data.status
  expressRow.value = data.row
  expressDrawerVisible.value = true
  if (data.info && data.info.length) {
    selectedPurchaseId.value = data.info?.[0].purchaseId
  }
}
expose({
  open
})
// 是否超时
const checkTime = (time: any) => {
  if (!time) return
  time = dayjs(new Date(time)).format('YYYY-MM-DD')
  return new Date(time + ' 23:59:59').getTime() < new Date().getTime()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Drawer, {
    visible: expressDrawerVisible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((expressDrawerVisible).value = $event)),
    onBeforeClose: close,
    title: _unref(t)('跟单进度'),
    "show-btn": false,
    size: "740px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: expressRow.value.productSkuImg ?? expressRow.value.productMainImg,
            alt: "",
            class: "product-img"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(expressRow.value.productTitleJp), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(expressRow.value.productPropertiesName), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(productStatsEnum)[Number(expressStatus.value)]) + "（" + _toDisplayString(expressRow.value[productStatsKeyEnum[Number(expressStatus.value)]] ?? 0) + "） ", 1)
            ])
          ])
        ]),
        (!expressInfo.value || expressInfo.value?.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('現時点では追跡情報を取得できません。暫くしてからもう一度お試し下さい')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (Number(expressInfo.value.length) > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expressInfo.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(selectedPurchaseId.value === item.purchaseId ? 'express-drawer-active' : 'express-drawer-default'),
                        key: index,
                        onClick: ($event: any) => (selectedPurchaseId.value = item.purchaseId)
                      }, _toDisplayString(`${_unref(productStatsEnum)[Number(expressStatus.value)]}（${item.num}）`), 11, _hoisted_14))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (getExpressInfoItemRespDtos()?.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('現時点では追跡情報を取得できません。暫くしてからもう一度お試し下さい')), 1)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(getExpressInfoItemRespDtos(), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "express-drawer-info",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('跟单反馈时间')) + "：" + _toDisplayString(_unref(getJapanTime)(item.createTime)), 1),
                      (getTipsText(item))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(getTipsClass(item))
                          }, [
                            _hoisted_19,
                            _createElementVNode("span", _hoisted_20, _toDisplayString(getTipsText(item)), 1)
                          ], 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          alt: "",
                          src: item.type == 1 ? 'https://static-s.theckb.com/BusinessMarket/Client/inDomesticTransitIcon.png' : 'https://static-s.theckb.com/BusinessMarket/Client/deliveryTimeIcon.png',
                          style: {"width":"60px"}
                        }, null, 8, _hoisted_22),
                        _createElementVNode("div", _hoisted_23, [
                          (getStockTime(item))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createTextVNode(_toDisplayString(getStockTime(item)?.text) + " ", 1),
                                _createElementVNode("span", _hoisted_25, _toDisplayString(getStockTime(item)?.time), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.type == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("span", null, [
                                  _createTextVNode(_toDisplayString(_unref(t)('中国国内运输物流编号')), 1),
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(item.logisticsNumber), 1)
                                ]),
                                _createElementVNode("div", {
                                  class: "express-drawer-box-item-time-bottom",
                                  onClick: ($event: any) => (item.show = !item.show)
                                }, [
                                  _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('点击查看物流状态')), 1),
                                  (!item.show)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_31))
                                ], 8, _hoisted_28)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (item.show)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (item.kuaiDiTrackItemList && item.kuaiDiTrackItemList.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass([{ line: item.kuaiDiTrackItemList?.length > 1 }, 'express-log-item'])
                                  }, [
                                    _hoisted_33,
                                    (item.kuaiDiTrackItemList?.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                          _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, [
                                              _createElementVNode("span", _hoisted_37, _toDisplayString(item.kuaiDiTrackItemList[0].time), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_38, _toDisplayString(item.kuaiDiTrackItemList[0].context), 1)
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.kuaiDiTrackItemList, (temp, k) => {
                                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                                              class: "express-log-status",
                                              key: k
                                            }, [
                                              _createElementVNode("div", _hoisted_39, [
                                                _createElementVNode("span", _hoisted_40, _toDisplayString(temp.time), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_41, _toDisplayString(temp.context), 1)
                                            ], 512)), [
                                              [_vShow, k !== 0 && k !== item.kuaiDiTrackItemList.length - 1]
                                            ])
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  (item.kuaiDiTrackItemList?.length > 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                        _hoisted_43,
                                        _createElementVNode("div", _hoisted_44, [
                                          _createElementVNode("div", _hoisted_45, [
                                            _createElementVNode("div", _hoisted_46, [
                                              _createElementVNode("span", _hoisted_47, _toDisplayString(item.kuaiDiTrackItemList[item.kuaiDiTrackItemList.length - 1].time), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_48, _toDisplayString(item.kuaiDiTrackItemList[item.kuaiDiTrackItemList.length - 1].context), 1)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                  _hoisted_50,
                                  _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(t)('現時点では追跡情報を取得できません。暫くしてからもう一度お試し下さい')), 1)
                                ]))
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
            ]))
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})